import requestApiKey from 'utils/requestApiKey';

const url = 'https://open.post.kz/npi/api';

export interface AddressLink {
    href: string;
}

export interface AddressLinks {
    self?: AddressLink;
    "qr-code"?: AddressLink;
    "address-parts"?: AddressLink;
}

export interface AddressDto {
    postcode: string;
    addressKaz: string;
    addressRus: string;
    addressLat: string;
    type: string;
    actual: boolean;
    address: string;
    _links: AddressLinks;
}

export interface ResponseDto<T> {
    data: T[];
    _links: AddressLinks;
    message?: string;
    status?: string;
}

export async function fetchAddresses(query: string): Promise<AddressDto[]> {
    const res = await requestApiKey(`${url}/postcode/search?from=0&size=20&lang=ru&query=${query}`).then(
        ({ data }) => (data.data || []) as AddressDto[]
    );
    return res;
}
